import { create } from "zustand";

/**
 * Client/global UI state only (skill section 3) — never server data. Server
 * data (jobs, songs, ...) always lives in TanStack Query; the URL owns
 * anything shareable (filters/pagination via nuqs).
 */
interface AdminShellState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useAdminShellStore = create<AdminShellState>((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
}));
